<!-- Common -->
<ng-template
  #commonPart
  let-option="option">
  <div
    class="gd-main-menu-option-label"
    fxLayout="row"
    [matTooltip]="expanded || !option.link || !option.icon ? undefined : (option.label | translate)"
    matTooltipPosition="after"
    matTooltipTouchGestures="off">

    <!-- Icon -->
    <div
      fxGrow="0"
      class="material-icons gd-main-menu-option-label-icon">{{option.icon}}</div>

    <!-- label -->
    <div
      fxFlex
      class="gd-main-menu-option-label-text">
      {{option.label | translate}}
    </div>
  </div>
</ng-template>

<!-- Menu -->
<mat-accordion
  #mainMenu
  class="gd-main-menu"
  [class.gd-version-not-visible]="!expanded || !versionData"
  [class.gd-mobile-device]="isTouchDevice"
  displayMode="flat">

  <!-- Menu options -->
  <ng-container
    *ngFor="let group of menuGroups">
    <ng-container
      *ngIf="group.visible">

      <!-- Label -->
      <div
        class="gd-main-menu-group-label">
        <ng-container
          *ngIf="expanded">
          {{group.label | translate}}
        </ng-container>
      </div>

      <!-- Children -->
      <ng-container
        *ngFor="let menuOption of group.options">
        <ng-container
          *ngIf="menuOption.visible">

          <!-- Menu without children - link -->
          <a
            *ngIf="menuOption.link; else childrenPanel"
            class="gd-main-menu-option gd-main-menu-option-link"
            [routerLink]="menuOption.link"
            routerLinkActive="gd-main-menu-option-active"
            [routerLinkActiveOptions]="activeSetup">
            <div
              class="gd-main-menu-option-header">
              <ng-template
                [ngTemplateOutlet]="commonPart"
                [ngTemplateOutletContext]="{ option: menuOption }"></ng-template>
            </div>
          </a>

          <!-- Menu with children -->
          <ng-template
            #childrenPanel>

            <!-- Panel -->
            <mat-expansion-panel
              *ngIf="expanded; else floatingMenu"
              class="gd-main-menu-option">

              <!-- Menu Header -->
              <mat-expansion-panel-header
                class="gd-main-menu-option-header">
                <mat-panel-title>
                  <ng-template
                    [ngTemplateOutlet]="commonPart"
                    [ngTemplateOutletContext]="{ option: menuOption }"></ng-template>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Children when menu is expanded -->
              <div
                class="gd-main-menu-option-children">
                <ng-container
                  *ngFor="let menuOptionChild of menuOption.children">
                  <ng-container
                    *ngIf="menuOptionChild.visible">

                    <!-- Child Menu link -->
                    <a
                      class="gd-main-menu-option gd-main-menu-option-link"
                      [routerLink]="menuOptionChild.link"
                      routerLinkActive="gd-main-menu-option-active"
                      [routerLinkActiveOptions]="activeSetup">
                      <div
                        class="gd-main-menu-option-header">
                        <ng-template
                          [ngTemplateOutlet]="commonPart"
                          [ngTemplateOutletContext]="{ option: menuOptionChild }"></ng-template>
                      </div>
                    </a>

                  </ng-container>
                </ng-container>
              </div>

            </mat-expansion-panel>

            <!-- Floating menu -->
            <ng-template
              #floatingMenu>

              <!-- Icon -->
              <div
                #levelOneTrigger="matMenuTrigger"
                class="gd-main-menu-option"
                [class.gd-main-menu-option-margin-right]="mainMenu.scrollHeight <= mainMenu.clientHeight"
                [matMenuTriggerFor]="menu"
                (menuOpened)="mainMenuOpened(menuOption, levelOneTrigger)"
                (menuClosed)="mainMenuClosed(menuOption)"
                (mouseenter)="menuOptionEnter(menuOption, levelOneTrigger)"
                (mouseleave)="menuOptionLeave(menuOption)">
                <div
                  class="gd-main-menu-option-header">
                  <ng-template
                    [ngTemplateOutlet]="commonPart"
                    [ngTemplateOutletContext]="{ option: menuOption }"></ng-template>
                </div>
              </div>

              <!-- Floating menu -->
              <mat-menu
                #menu="matMenu"
                class="gd-main-menu-option-float-menu {{menuOption.id}}"
                [hasBackdrop]="false">
                <div
                  (mouseenter)="floatingMenuEnter(menuOption)"
                  (mouseleave)="floatingMenuLeave(menuOption)">

                  <!-- Floating menu title -->
                  <div
                    class="gd-main-menu-option-float-menu-title"
                    (click)="$event.preventDefault(); $event.stopPropagation(); $event.stopImmediatePropagation();">
                    {{menuOption.label | translate}}
                  </div>

                  <!-- Menu options -->
                  <ng-container
                    *ngFor="let menuOptionChild of menuOption.children">
                    <ng-container
                      *ngIf="menuOptionChild.visible">

                      <!-- Child Menu link -->
                      <a
                        class="gd-main-menu-option-header-button"
                        mat-menu-item
                        [routerLink]="menuOptionChild.link"
                        routerLinkActive="gd-main-menu-option-active"
                        [routerLinkActiveOptions]="activeSetup">
                        <ng-template
                          [ngTemplateOutlet]="commonPart"
                          [ngTemplateOutletContext]="{ option: menuOptionChild }"></ng-template>
                      </a>

                    </ng-container>
                  </ng-container>
                </div>
              </mat-menu>
            </ng-template>

          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-accordion>

<!-- Version -->
<div
  *ngIf="expanded && versionData"
  class="gd-version">
  {{ 'LNG_LAYOUT_MENU_VERSION_LABEL' | translate: { version: versionData.version, build: versionData.build } }}
</div>
